import * as React from "react";
import { useState } from "react";
import {
  Box,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Typography,
  Chip,
  Tooltip
} from "@mui/material";
import { priceFormat } from "src/common/UtilFunctions";
import { RemoveItemModal, EditItemModal, AddItemModal } from "src/resources/sales/forms";
import { OrderItemProps } from "src/resources/sales/interface";

export const ItemsTable = (props) => {
  const { record, currency, ...rest } = props;

  const [addItemOpen, setAddItemOpen] = useState(false);
  const [removeItemOpen, setRemoveItemOpen] = useState(false);
  const [removeItem, setRemoveItem] = useState(null);
  const [editItemOpen, setEditItemOpen] = useState(false);
  const [editItem, setEditItem] = useState(null);

  const removeItemHandler = (orderItem: OrderItemProps) => {
    setRemoveItem(orderItem);
    setRemoveItemOpen(true);
  }

  const setRemoveItemOpenHandler = (value: boolean) => {
    setRemoveItem(null);
    setRemoveItemOpen(value);
  }

  const editItemHandler = (orderItem: OrderItemProps) => {
    setEditItem(orderItem);
    setEditItemOpen(true);
  }

  const setEditItemOpenHandler = (value: boolean) => {
    setEditItem(null);
    setEditItemOpen(value);
  }

  return (
    <>
    <TableContainer sx={{border: "1px solid #ebebeb", borderRadius: "8px", boxShadow: "0px 1px 1px rgba(100, 116, 139, 0.06), 0px 1px 2px rgba(100, 116, 139, 0.1)"}}>
        <Table size="small">
            <TableHead>
            <TableRow>
                <TableCell>
                Product
                </TableCell>
                <TableCell>
                Sidemark
                </TableCell>
                <TableCell>
                Orginal Price
                </TableCell>
                <TableCell>
                Price
                </TableCell>
                <TableCell>
                Quantity{record.type === 'fabric' && ' (Yards)'}
                </TableCell>
                <TableCell>
                Subtotal
                </TableCell>
                <TableCell>
                Tax Amount
                </TableCell>
                <TableCell>
                Tax Percent
                </TableCell>
                <TableCell>
                Total
                </TableCell>
                <TableCell/>
            </TableRow>
            </TableHead>

            <TableBody>
            { record.items.map((orderItem, orderItemIndex) => {
                return (
                    <TableRow key={`row_${orderItemIndex}`} >
                        <TableCell>
                            <Typography variant="body2" component="div" sx={{display: "flex", flexWrap: "nowrap", alignItems: "center"}}>
                                {orderItem?.product?.parent?.name && orderItem?.product?.parent?.name+" / "}{orderItem?.product?.name}
                                {orderItem.group_items?.length > 0 &&
                                <Tooltip placement="top" describeChild title={orderItem.group_items.map((item) => item.sku).join(', ')}>
                                <Chip
                                    sx={{height: "22px", fontWeight: "500", marginLeft: "10px", cursor: "pointer", paddingBottom: "2px"}}
                                    label="Ringset"
                                />
                                </Tooltip>
                                }
                            </Typography>
                            {orderItem.product.sku}
                        </TableCell>
                        <TableCell>
                            {orderItem.note}
                        </TableCell>
                        <TableCell>
                            {priceFormat(orderItem.original_price, currency)}
                        </TableCell>
                        <TableCell>
                            {priceFormat(orderItem.price, currency)}
                        </TableCell>
                        <TableCell>
                            {orderItem.quantity}
                        </TableCell>
                        <TableCell>
                            {priceFormat(orderItem.sub_total, currency)}
                        </TableCell>
                        <TableCell>
                            {priceFormat(orderItem.tax_amount, currency)}
                        </TableCell>
                        <TableCell>
                            {orderItem.tax_percent}%
                        </TableCell>
                        <TableCell>
                            {priceFormat(orderItem.total, currency)}
                        </TableCell>
                        <TableCell sx={{display: "flex", justifyContent: "end"}}>
                            <Button onClick={() => editItemHandler(orderItem)}>Edit</Button>
                            <Button onClick={() => removeItemHandler(orderItem)}>Remove</Button>
                        </TableCell>
                    </TableRow>
                )   
            })}
            </TableBody>
        </Table>
        <Box display="flex" justifyContent="end" sx={{padding: "6px 16px"}}>
            <Button onClick={() => setAddItemOpen(true)}>Add Item</Button>
        </Box>
    </TableContainer>

    <AddItemModal
        open={addItemOpen}
        setOpen={setAddItemOpen}
        record={record}
    />

    {removeItemOpen && 
    <RemoveItemModal
        open={removeItemOpen}
        setOpen={setRemoveItemOpenHandler}
        orderItem={removeItem}
    />
    }

    {editItemOpen && 
    <EditItemModal
        open={editItemOpen}
        setOpen={setEditItemOpenHandler}
        orderItem={editItem}
    />
    }
    </>
  );
}
